import { render, staticRenderFns } from "./contacts.vue?vue&type=template&id=46af3f0f&scoped=true"
import script from "./contacts.vue?vue&type=script&lang=js"
export * from "./contacts.vue?vue&type=script&lang=js"
import style0 from "./contacts.vue?vue&type=style&index=0&id=46af3f0f&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../szc.cycz.cc/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46af3f0f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/www/wwwroot/szc.cycz.cc/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('46af3f0f')) {
      api.createRecord('46af3f0f', component.options)
    } else {
      api.reload('46af3f0f', component.options)
    }
    module.hot.accept("./contacts.vue?vue&type=template&id=46af3f0f&scoped=true", function () {
      api.rerender('46af3f0f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Contacts/contacts.vue"
export default component.exports